import {
  Component, ChangeDetectionStrategy, AfterContentInit, QueryList, ContentChildren, DestroyRef, inject,
} from '@angular/core'
import {
  skip, startWith, takeUntil,
} from 'rxjs'
import { AccordionPanelComponent } from './accordion-panel/accordion-panel.component'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'kb-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class AccordionComponent implements AfterContentInit {
  @ContentChildren(AccordionPanelComponent) protected panelElements!: QueryList<AccordionPanelComponent>

  private destroyRef = inject(DestroyRef)

  public ngAfterContentInit(): void {
    const panelElementsChanges = this.panelElements.changes.pipe(
      startWith(this.panelElements),
      takeUntilDestroyed(this.destroyRef),
    )

    panelElementsChanges.subscribe((panelElements: QueryList<AccordionPanelComponent>) => {
      panelElements.forEach((panelElement) => {
        panelElement.expand.pipe(
          takeUntil(panelElementsChanges.pipe(skip(1))),
          takeUntilDestroyed(this.destroyRef),
        ).subscribe(() => {
          panelElements
            .filter(element => element !== panelElement)
            .forEach(element => element.expanded = false)
        })
      })
    })
  }
}
